const Auth = {
  tokenKey: 'token',
  userKey: 'user',
  selectedCompanyKey: 'selectedCompany',
  authorizedRedirectionPath: '/users',
  unauthorizedRedirectionPath: '/login',
  noPermissionsRedirectionPath: '/no-permissions',
  projectSelectPath: '/project-select',
};

export const SubjectRouteMap: Record<string, string> = {
  "Kullanıcılar": "/users",
  "Birimler": "/departments",
  "Projeler": "/projects",
  "Vardiyalar": "/shifts",
  "Vardiya Raporları": "/shift-reports",
  "Devriye Planları": "/patrol-plans",
  "Devriye Rotaları": "/patrol-routes",
  "Tamamlanan Devriyeler": "/completed-patrols",
  "Devriye-Raporu": "/patrol-report",
  "Profil": "/profile",
  "Olumsuzluk Bildirimi": "/reportDetail",
  "Talep": "/request-module",
  "Bildirimler-Devriye": "/patrol-notifications",
  "Bildirimler": "/notifications",
  "Talimatlar": "/instructions",
  "Bildirimler-Güvenlik-Görevlisine-Bildirim-Gönder": "/security-guard-notifications",
  "Bildirimler-Opersyon-ve-Denetim": "/operation-audit-notifications",
  "Rol": "/roles",
  "Dokümanlar": "/documents",
  "Dokümanlar-Operasyon": "/documents/operasyon",
  "Dokümanlar-Lojistik": "/documents/lojistik",
  "Dokümanlar-Personel-ve-İK": "/documents/personel-ve-ik",
  "Dokümanlar-Satın-Alma": "/documents/satin-alma",
  "Dokümanlar-Proje": "/documents/proje",
  "Dokümanlar-5188-Sorumlusu": "/documents/5188-sorumlusu",
  "Dokümanlar-Satış-Pazarlama-ve-Reklam": "/documents/satis-pazarlama-ve-reklam",
  "Dokümanlar-Para-ve-Değerli-Eşya-Nakli": "/documents/para-ve-degerli-esya-nakli",
  "Dokümanlar-Maliye": "/documents/maliye",
  "Dokümanlar-Eğitim": "/documents/egitim",
  "Dokümanlar-Bilgi-Teknolojileri-ve-Güvenlik-Mühendisliği": "/documents/bilgi-teknolojileri-ve-elektronik-guvenlik-muhendisligi",
  "Dokümanlar-Kalite-Yönetimi": "/documents/kalite-yonetimi",
  "Dokümanlar-Kurumsal-İletişim-ve-Basın": "/documents/kurumsal-iletisim-ve-basin",
  "Dokümanlar-Genel": "/documents/genel",
  "Dokümanlar-Denetleme-Raporları": "/documents/denetleme-raporlari",
};

export function getFirstAccessibleRoute(permissions: any[]): string {
  for (const perm of permissions) {
    if (
      (perm.action === "manage" || perm.action === "read") &&
      perm.subject &&
      SubjectRouteMap[perm.subject.name]
    ) {
      return SubjectRouteMap[perm.subject.name];
    }
  }
  return Auth.noPermissionsRedirectionPath;
}

export default Auth;
